import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {option} from "ts-option";
import User from "../../../model/user/User";
import LeadAgentSelector from "../v4/agentSelector/LeadAgentSelector";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<string> & PlaceholderProps;

/**
 * Agent selector form view group.
 */
export default class AgentSelectorFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<div>
					<LeadAgentSelector agentId={this.props.field.getOptionalValue()} onChange={this.onChange}/>
				</div>
			</FormGroup>
		);
	}

	/**
	 * Callback on agent changed.
	 * @param user
	 */
	onChange(user: User) {
		this.props.onChange(this.props.field.updateValue(option(user.id)));
	}
}
